export default "__VITE_ASSET__BpIYbOLf__"